import React from 'react';
import './Footer.css';

export const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer__container">

        <div className="footer__bottom">
          <div className="footer__attribution">
            <p className="footer__attribution-label">Technology and Analysis by</p>
            <div className="footer__company">
              <a
                href="https://www.thegreenconcept.co.in/"
                target="_blank"
                rel="noopener noreferrer"
                className="footer__company-link"
              >
                <img
                  src={`${process.env.PUBLIC_URL}/assets/logoHighRes.png`}
                  alt="The Green Concept"
                  className="footer__company-logo"
                  onError={(e) => {
                    e.currentTarget.style.display = 'none';
                  }}
                />
                <span className="footer__company-name">The Green Concept</span>
              </a>
            </div>
            <p className="footer__company-contact">
              <a href="https://www.thegreenconcept.co.in/" target="_blank" rel="noopener noreferrer">
                www.thegreenconcept.co.in
              </a>
              {' • '}
              <a href="mailto:info@thegreenconcept.co.in">info@thegreenconcept.co.in</a>
            </p>
          </div>

        </div>
      </div>

      {/* Decorative botanical pattern */}
      <div className="footer__pattern" />
    </footer>
  );
};

export default Footer;
